import { Component, OnInit ,ChangeDetectionStrategy ,ViewChild ,VERSION} from '@angular/core';
import { Category, CategoryItem, ListImages, MainListObject } from 'src/app/models/category';
import { ChangeFood, OpenningHours} from 'src/app/models/restaurant'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LoginComponent } from '../login/login.component';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import { AppComponent } from '../../app.component';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/services/user-service';
import { BussinssService } from 'src/app/services/bussinss-service';
import { AppProxy } from 'src/app/services/app-proxy';
//import { SlickModule } from 'ngx-slick';
   import { SliderComponent } from '../slider/slider.component';
   import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import {CarouselModule} from 'primeng/carousel';
import { OrdersService } from 'src/app/services/order-service';
import { MyOrder } from 'src/app/models/order';
import { PopupOrderComponent } from '../popup-order/popup-order.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit{


constructor(private orderService:OrdersService , public gallery: Gallery, public lightbox: Lightbox,private proxy: AppProxy,config: NgbCarouselConfig,private userService:UserService,private bussinssService: BussinssService,private matDialog:MatDialog,private router: Router,private app:AppComponent) { 
  config.interval = 1500;
  config.wrap = true;
  config.keyboard = true;
  config.pauseOnHover = true;
}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    throw new Error('Method not implemented.');
  }
  
   categoresItem: CategoryItem[];
  categoresItemLastMenu: ListImages[] = [];
  mainListObject: MainListObject[] = [];
  currentIndex: number = 0;
  public currentIndices: number[] = [];
  private itemsPerView = 6;
  private activeIndex: number = 0;
  items: GalleryItem[];
  Rate = new Array<number>(3);
  imageData = data;
  order: MyOrder;
  showProgress = false;

private itemWidth = 226;
private itemPadding = 7; // Define padding size


getSliderPosition(groupIndex: number): number {
  // Include padding in position calculation
  return this.currentIndices[groupIndex] * (this.itemWidth + (this.itemPadding * 2));
}

slideLeft(groupIndex: number) {
  if (this.canSlideLeft(groupIndex)) {
    // Move by 6 items at a time
    this.currentIndices[groupIndex] = Math.max(0, this.currentIndices[groupIndex] - this.itemsPerView);
  }
}

slideRight(groupIndex: number) {
  if (this.canSlideRight(groupIndex)) {
    const categoryGroup = this.mainListObject[groupIndex];
    this.currentIndices[groupIndex] = Math.min(
   ( categoryGroup.IsCategories == 1 ?  categoryGroup.categories.length : categoryGroup.list.length) - this.itemsPerView,
      this.currentIndices[groupIndex] + this.itemsPerView // Move by 6 items at a time
    );
  }
}
  
  canSlideLeft(groupIndex: number): boolean {
    return this.currentIndices[groupIndex] > 0;
  }
  
  canSlideRight(groupIndex: number): boolean {
   
    const categoryGroup = this.mainListObject[groupIndex];
    categoryGroup.IsCategories == 0 ?console.log(categoryGroup.ListName):null;
    return this.currentIndices[groupIndex] < ((categoryGroup.IsCategories == 1?categoryGroup.categories.length : categoryGroup.list.length) - this.itemsPerView);
  }
private restaurantItemWidth = 347;
  private restaurantItemPadding = 6.5;
  private restaurantsPerView = 4;
  private restaurantCurrentIndices: number[] = [];

  getRestaurantSliderPosition(groupIndex: number): number {
    return this.restaurantCurrentIndices[groupIndex] * 
           (this.restaurantItemWidth + (this.restaurantItemPadding * 2));
  }

  slideRestaurantLeft(groupIndex: number) {
    if (this.canRestaurantSlideLeft(groupIndex)) {
      this.restaurantCurrentIndices[groupIndex] = Math.max(
        0, 
        this.restaurantCurrentIndices[groupIndex] - this.restaurantsPerView
      );
    }
  }

  slideRestaurantRight(groupIndex: number) {
    if (this.canRestaurantSlideRight(groupIndex)) {
      const categoryGroup = this.mainListObject[groupIndex];
      this.restaurantCurrentIndices[groupIndex] = Math.min(
        categoryGroup.list.length - this.restaurantsPerView,
        this.restaurantCurrentIndices[groupIndex] + this.restaurantsPerView
      );
    }
  }

  canRestaurantSlideLeft(groupIndex: number): boolean {
    return this.restaurantCurrentIndices[groupIndex] > 0;
  }

  canRestaurantSlideRight(groupIndex: number): boolean {
    const categoryGroup = this.mainListObject[groupIndex];
    return this.restaurantCurrentIndices[groupIndex] < 
           (categoryGroup.list.length - this.restaurantsPerView);
  }


  openDialog() {
    if(localStorage.ACCESS_TOKEN  == "null" || localStorage.ACCESS_TOKEN  == null || localStorage.ACCESS_TOKEN  == "")
    {
      localStorage.ACCESS_TOKEN  = "null";
    const dialogConfig = new MatDialogConfig();
    this.matDialog.open(LoginComponent, { disableClose: true });
    }
  }
  
  // onClickCategory(id:number){
  //   if(localStorage.ACCESS_TOKEN  != "null"  && localStorage.SMS_CODE!="")
  // {
  //   localStorage.ID=id;
  //   this.orderService.restaurant=null;
  //   this.router.navigate(['../restaurant']);
  // }
  // else
  // this.proxy.showError("אינך מחובר נא להתחבר","");
  //  //this.bussinssService.getRestaurantDetails(id,false,false,false,null);
  // }



  more(i:number){
    if(localStorage.SMS=="")
   this.proxy.showError("חובה להכניס קוד","");
    else if(localStorage.ACCESS_TOKEN  == "null"  || localStorage.SMS_CODE=="")
    this.proxy.showError("אינך רשום למערכת","");
    else
    {
   this.bussinssService.mainRestaurantItemList = this.mainListObject[i].list;
      this.bussinssService.categoryName = this.mainListObject[i].ListName;
      localStorage.TEXT_SEARCH = "all";

      localStorage.ID = this.mainListObject[i].ListID; // Adjusting index to match API expectations
      if (this.bussinssService.mainRestaurantItemList.length > 0)
        this.router.navigate(['../../mainList'])
    }
  }

  ngOnInit(): void {
    this.openDialog();
    window.scroll(0,0);
    localStorage.Category = "1";
    localStorage.TEXT_SEARCH="";
    this.categoresItemLastMenu=[];
     this.bussinssService.getListImages().subscribe((res: any) => {
      this.categoresItemLastMenu = res
      localStorage.TEXT_SEARCH = "";

   
    localStorage.TEXT_SEARCH="";
     this.bussinssService.getAllMainList(localStorage.LAT, localStorage.LONG,).subscribe((res: MainListObject[]) => {
      this.mainListObject = res;
        this.currentIndices = this.mainListObject.map(() => 0);
        this.restaurantCurrentIndices = this.mainListObject.map(() => 0);
      this.showProgress = false;
    });
        });
    window.scroll(0, 0);



  this.items = this.imageData.map(item => new ImageItem({ src: item.srcUrl, thumb: item.previewUrl }));


    /** Lightbox Example */

    // Get a lightbox gallery ref
    const lightboxRef = this.gallery.ref('lightbox');

    // Add custom gallery config to the lightbox (optional)
    lightboxRef.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top
    });

    // Load items into the lightbox gallery ref
    lightboxRef.load(this.items);
  }

  imgSlide(pos:number)
  {
    if(this.categoresItemLastMenu[pos].BusinessUrl!=undefined && this.categoresItemLastMenu[pos].BusinessUrl!=null)
    var fields = this.categoresItemLastMenu[pos].BusinessUrl.split('=');
    let orderId=Number(fields[1]);
  this.bussinssService.getOpenningHours2(orderId).subscribe((res: boolean) => {
      
      if (res == false)
        this.proxy.showError("המסעדה סגורה\n אין אפשרות לבצע הזמנה", "");
     
      else {
      this.orderService.getOrderDetails(false).subscribe((res:any)=>{
             localStorage.ID = orderId;
          // this.router.navigate(['../restaurantCategory']);
          if (this.order.OrderID == 0 && (this.order.list == null || this.order.list.length == 0)) {
      
            sessionStorage.CATEGORY_FILTER = "";
            this.bussinssService.getBusinessEnName(orderId).subscribe((res: any) => {
              let nameEn=res;
             
    
            let url: string = "/restaurant/" + nameEn;
            this.router.navigateByUrl(url);
            });
           // this.router.navigate(['../restaurant']);
          }
      else
      {
        this.matDialog.open(PopupOrderComponent, {
          data: { OrderID: this.order.OrderID },
        });
      }
    });
  }});}
}
const data = [
  {
    srcUrl: 'https://preview.ibb.co/jrsA6R/img12.jpg',
    previewUrl: 'https://preview.ibb.co/jrsA6R/img12.jpg'
  },
  {
    srcUrl: 'https://preview.ibb.co/kPE1D6/clouds.jpg',
    previewUrl: 'https://preview.ibb.co/kPE1D6/clouds.jpg'
  },
  {
    srcUrl: 'https://preview.ibb.co/mwsA6R/img7.jpg',
    previewUrl: 'https://preview.ibb.co/mwsA6R/img7.jpg'
  },
  {
    srcUrl: 'https://preview.ibb.co/kZGsLm/img8.jpg',
    previewUrl: 'https://preview.ibb.co/kZGsLm/img8.jpg'
  }
];
